import HttpRequest from './HttpRequest';

export default class PageTemplateService extends HttpRequest {
  static endpoint = 'page-template';

  static async getAll() {
    this.endpoint = 'page-template';
    const response = await this.get();
    return response;
  }

  static async getById(id) {
    this.endpoint = 'page-template';
    const response = await this.get(id);
    return response;
  }

  static async getByTemplate(templateId) {
    this.endpoint = 'page-template/by-template';
    const response = await this.get(templateId);
    return response;
  }

  static async create(data) {
    this.endpoint = 'page-template';
    const response = await this.post(data);
    return response;
  }

  static async update(id, data) {
    this.endpoint = 'page-template';
    const response = await this.put(id, data);
    return response;
  }

  static async remove(id) {
    this.endpoint = 'page-template';
    const response = await this.delete(id);
    return response;
  }
}
